enum SocialReportRequest {
  Total = 'SOCIAL_TOTAL',

  Date = 'SOCIAL_DATE',
  Platform = 'SOCIAL_PLATFORM',
  Agency = 'SOCIAL_AGENCY',
  Advertiser = 'SOCIAL_ADVERTISER',
  Campaign = 'SOCIAL_CAMPAIGN',
  Placement = 'SOCIAL_PLACEMENT',
  AdName = 'SOCIAL_AD_NAME',
}

export default SocialReportRequest;
